import URI from "urijs";

const API_PREFIX = process.env.REACT_APP_API_HOST;

export class Api {
  authToken: string | null = null;
  errorHandler: Function = () => {};

  setErrorHandler(errorHandler: Function) {
    this.errorHandler = errorHandler;
  }

  fetchResponse(path: string, request: any = {}) {
    request.headers["Authorization"] = `bearer ${this.authToken}`;
    // request.headers = {
    //   // "Content-Type": "application/json",
    //   // "Content-Type": request.headers["Content-Type"]
    //   //   ? request.headers["Content-Type"]
    //   //   : "application/json",
    //   "Content-Type": request.headers?.["Content-Type"],
    //   Authorization: `bearer ${this.authToken}`,
    // };

    request.body =
      request.headers &&
      request.headers["Content-Type"] &&
      request.headers["Content-Type"].includes("application/json")
        ? JSON.stringify(request.body)
        : request.body;

    if (request.headers["Content-Type"] === "multipart/form-data") {
      delete request.headers["Content-Type"];
    }

    return fetch(path, request).then(async (response) => {
      const result = {
        status: response.status,
        headers: response.headers,
        body: {} as any,
      };
      if (response.body) {
        result.body = await response.json();
        if (result.body.auth) {
          this.authToken = result.body.auth.token;
        }
      }
      if (response.status === 200 || response.status === 201) {
        return result;
      }
      throw result;
    });
  }

  uri() {
    return new URI(API_PREFIX);
  }

  get(path: string) {
    return this.fetchResponse(path, {
      headers: { "Content-Type": "application/json" },
    });
  }

  post(path: string, data: any = {}) {
    return this.fetchResponse(path, {
      body: data,
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
  }

  postFormData(path: string, data: FormData) {
    return this.fetchResponse(path, {
      body: data,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  patch(path: string, data: any = {}) {
    return this.fetchResponse(path, {
      body: data,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
    });
  }

  delete(path: string) {
    return this.fetchResponse(path, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });
  }

  setAuthToken(token: string) {
    this.authToken = token;
  }
}

const api = new Api();
export default api;
